// You should update the variable sometimes as IOS application is doing it
// It used to proper version check and prevents users to use outdated application
export const BUILT_ON_API_VERSION = '1.0.0';
